import { BreachEvent, DataLayerEventName } from '@news-mono/web-common'
import React, { useEffect } from 'react'
import { RegistrationWallForm } from './components/RegistrationWallForm'
import {
    StyledJoinMessage,
    StyledRegistrationInfo,
    StyledRegistrationWall,
    StyledTitle,
} from './RegistrationWall.styled'

export interface RegistrationWallProps {
    onEvent: (event: any) => void
    position?: number
}

export const RegistrationWall: React.FC<RegistrationWallProps> = ({
    onEvent,
    position,
}) => {
    const eventPayload: BreachEvent['payload'] = {
        paywallType: 'freemium',
        leadDepth: position || 0,
        creative: 'registration wall - launch',
        breachScreenType: 'Registration - Inline',
        popupMethod: 'auto',
        deal: '',
        pricepoint: [],
    }

    // Fire the available event
    useEffect(() => {
        onEvent({
            type: DataLayerEventName.breachScreenAvailable,
            originator: 'breachscreen',
            payload: eventPayload,
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <StyledRegistrationWall>
            <StyledRegistrationInfo>
                <StyledTitle>
                    Be in <br /> the know.
                </StyledTitle>
                <StyledJoinMessage>
                    Register for free access to this article and a selection of
                    others.
                </StyledJoinMessage>
            </StyledRegistrationInfo>
            <RegistrationWallForm
                onEvent={onEvent}
                eventPayload={eventPayload}
            />
        </StyledRegistrationWall>
    )
}
RegistrationWall.displayName = 'RegistrationWall'

export default RegistrationWall
